import React, {Component} from 'react';
import GoogleMapReact from 'google-map-react';
import mapStyles from './mapstyles.js'
import './map.css';

class Map extends Component {
  static defaultProps = {
    zoom: 12
  }

  renderMarkers(map, maps) {

    var icon = { url : 'black-marker-icon.png', size: new maps.Size(40, 40) }

    let marker = new maps.Marker({
      position: {lat: this.props.lat, lng: this.props.lng},
      map,
    
    });
  }

  render() {

    let mapOptions = {
      styles: mapStyles
    };

    return (
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyCZ1EvxRhlXx1Mm4LCMk0GuHnMaJrUJzlc" }}
        defaultCenter={{lat: this.props.lat, lng: this.props.lng}}
        defaultZoom={this.props.zoom}
        onGoogleApiLoaded={({map, maps}) => this.renderMarkers(map, maps)}
        yesIWantToUseGoogleMapApiInternals
        options={mapOptions}
      >

      </GoogleMapReact>
    );
  }
}

export default Map
